<script setup lang="ts">
// WHERE AM I (Tom 2026-09-26, jobs #340 and #342): the mode the learner is in,
// as its icon on a see-through green disc, top right of the screen, in every
// mode. Icon only, no name. Status only — it takes no taps; the mixing-desk
// button bottom right stays the one way to change mode (Tom + Aran).
//
// The icon comes from ModeIcon.vue, the same drawing as the selector tray's
// rows, so the two cannot drift.
import type { PropType } from 'vue'
import { useI18n } from '../composables/useI18n'
import ModeIcon from './ModeIcon.vue'
import { modeNameKey, type Mode } from './modes'

defineProps({
  mode: { type: String as PropType<Mode | null>, default: null },
  visible: { type: Boolean, default: true },
  courseCode: { type: String, default: '' },
})

const { t } = useI18n()
</script>

<template>
  <Teleport to="body">
    <div
      v-if="mode && visible"
      class="mode-badge"
      role="status"
      :aria-label="t(modeNameKey(mode, courseCode))"
      :data-mode="mode"
    >
      <span class="mode-badge-icon"><ModeIcon :mode="mode" /></span>
    </div>
  </Teleport>
</template>

<style scoped>
/* The corner is the icon's: top right, clear of the notch and a landscape
   side inset. 28px, the green of the tray's lit row, half see-through so it
   sits quietly over whatever is behind it. Above the mode overlays (Listening,
   Script) and under the bottom nav, the tray and every sheet. */
.mode-badge {
  position: fixed;
  top: calc(env(safe-area-inset-top, 0px) + 14px);
  right: max(8px, env(safe-area-inset-right, 0px));
  width: 28px;
  height: 28px;
  z-index: 2800;
  pointer-events: none;
}

.mode-badge-icon {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(22, 163, 74, 0.45);
  color: rgba(255, 255, 255, 0.9);
}

.mode-badge-icon :deep(svg) {
  width: 16px;
  height: 16px;
}
</style>
